import { Heading } from '@chakra-ui/layout'
import { Layout } from 'components/atoms'
import { InputBuild } from 'components/molecules'
import { useContractContext } from 'contexts/contract'
import React, { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import isDisableToEditContract from '../../StepsForm/Utils/isDisableToEditContract'
import { FormContractProps } from '../FormContract/interfaces'
import { FormConsortiumValue } from './form'
import { FormConsortiumProps } from './interfaces'
import { FormConsortiumKeys } from './types'

const FormConsortium: React.FC = () => {
    const {
        register,
        watch,
        resetField,
        formState: { errors }
    } = useFormContext<{
        consortium: FormConsortiumProps
        contract: FormContractProps
    }>()

    const { typeContractBoolean } = useContractContext()

    const hasError = (id: FormConsortiumKeys) => {
        return errors.consortium && errors.consortium[id]
    }

    const typeOfRestriction = watch('contract.tipoRestricao')
    const form = useMemo(
        () => FormConsortiumValue(typeOfRestriction),
        [typeOfRestriction]
    )

    const resetFields = () => {
        resetField('consortium.cotaConsorcio')
        resetField('consortium.numeroGrupo')
    }

    useEffect(() => {
        resetFields()
    }, [typeOfRestriction])

    return (
        <Layout
            type="container"
            px={8}
            full
            display="grid"
            gap={8}
            data-testid="form-container"
        >
            <Layout type="row" data-testid="form-heading">
                <Heading size="md" textAlign={{ sm: 'center' }}>
                    Empresas administradoras de consórcio
                </Heading>
            </Layout>
            <Layout type="row" gutter={{ y: 1.5 }} data-testid="form-fields">
                {form.map(({ layout, input }, key) => (
                    <Layout {...layout} key={key}>
                        {input && (
                            <InputBuild
                                {...input}
                                err={hasError(input.id)}
                                {...register(`consortium.${input.id}`, {
                                    valueAsNumber: input.type === 'number'
                                })}
                                value={
                                    watch(`consortium.${input.id}`) as string
                                }
                                isDisable={
                                    typeContractBoolean &&
                                    isDisableToEditContract[
                                        `consortium.${input.id}`
                                    ]
                                }
                            />
                        )}
                    </Layout>
                ))}
            </Layout>
        </Layout>
    )
}

export default FormConsortium
